export const adaptFontSize = (size: string) => {
    return parseInt(size.replace("px", ""));
};
